import * as React from 'react'
import styled from 'styled-components'

import { FloatingHeader } from '~/components/floating-header'
import Modal from '~/components/modal'
import Overlay from '~/truck/overlay'

import { Filters } from '../../filters'
import { Footer } from '../footer'

interface FiltersMobileModalProps {
  onClose: () => void
}

const StyledOverlay = styled(Overlay)`
  height: 100%;
`

const StyledModal = styled(Modal.Standalone)`
  overflow-y: hidden;
  padding: 0;
`

const StyledFilters = styled(Filters)`
  height: 100%;
`

export function FiltersMobileModal(props: FiltersMobileModalProps) {
  const { onClose } = props

  return (
    <StyledOverlay open>
      <StyledModal>
        <FloatingHeader onClose={onClose} title="Filtros" />
        <StyledFilters>
          <Footer onShowClick={onClose} />
        </StyledFilters>
      </StyledModal>
    </StyledOverlay>
  )
}
